// extracted by mini-css-extract-plugin
export default {"header":"slider_header__mZAug","body":"slider_body__KWwVp","carousel":"slider_carousel__+NuwR","sliderImg":"slider_sliderImg__HdwHW"};